import { ArrowTopRightOnSquareIcon, ArrowUturnLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";

const OrendaFees: React.FC = () => {
  return (
    <div className="flex flex-col items-center container pt-20">
      {/* Header Section */}
      <header className="w-full px-5">
        <h1 className="text-4xl font-extrabold text-gray-900">Fee Information</h1>
        <p className="mt-4 text-lg text-gray-700">
          This document informs you about the fees for using the main services linked to the payment account. It will help you to compare these fees with those of other accounts. Fees may also apply for using services linked to the account which are
          not listed here. A glossary of the terms used in this document is available free of charge.
        </p>
      </header>

      <section id="why" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">Account Services</h3>

        <table className="min-w-full bg-white border border-gray-200 mt-4">
          <thead>
            <tr>
              <th className="px-4 py-2 border-b text-left">Fee Name *</th>
              <th className="px-4 py-2 border-b text-left">Fee (GBP)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-4 py-2 border-b">One Off Creation Of Each Iban Onboarding Fee </td>
              <td className="px-4 py-2 border-b">575.00</td>
            </tr>
            <tr>
              <td className="px-4 py-2 border-b">Incoming Faster Payments </td>
              <td className="px-4 py-2 border-b">0.5% + £0.50</td>
            </tr>
            <tr>
              <td className="px-4 py-2 border-b">Outgoing Faster Payments</td>
              <td className="px-4 py-2 border-b">0.5% + £0.50</td>
            </tr>
            <tr>
              <td className="px-4 py-2 border-b">Incoming BACS Credit Transfer </td>
              <td className="px-4 py-2 border-b">0.5% + £2</td>
            </tr>
          </tbody>
          
        </table>
        <p className="my-4 mx-2">* Maximum fee that can be charged.</p>
      </section>
    </div>
  );
};

export default OrendaFees;
